import { Action } from './action';
import { getNodeMatrix, MATRIX_UTILS, MatrixSerializer } from '../render/effects/matrix';

function condition(context) {
  const selectedNodes = context?.api?.getSelectedNodes() || [];
  return selectedNodes.length > 0;
}

export const flipHorizontalAction = new Action({
  name: 'flipHorizontal',
  handler: (context) => flipNodes(context, 'horizontal'),
  shortcuts: 'Shift+H',
  condition: condition,
});

export const flipVerticalAction = new Action({
  name: 'flipVertical',
  handler: (context) => flipNodes(context, 'vertical'),
  shortcuts: 'Shift+V',
  condition: condition,
});

function flipNodes(context, direction) {
  const selectedNodes = context.api.getSelectedNodes();

  if (selectedNodes.length === 0) {
    return;
  }

  selectedNodes.forEach((node) => {
    // 获取当前矩阵
    const matrix = getNodeMatrix(node) || MATRIX_UTILS.identity();
    // 构造翻转矩阵，确保以自身中心为翻转原点
    let flipMat;
    if (direction === 'horizontal') {
      flipMat = MATRIX_UTILS.multiply(matrix, MATRIX_UTILS.scale(-1, 1));
    } else if (direction === 'vertical') {
      flipMat = MATRIX_UTILS.multiply(matrix, MATRIX_UTILS.scale(1, -1));
    }

    context.api.updateNode(node.id, {
      transform: MatrixSerializer.serialize(flipMat),
      flipX: null,
      flipY: null,
    });
  });
}
